<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Имя пользователя клиента">
          <b-input
            name="username"
            placeholder="username"
            icon="user"
            v-model="model.username">
          </b-input>
        </b-field>
        <b-field label="Пароль" v-if="id">
          <b-input
            icon="key"
            placeholder="password"
            disabled
            v-model="model.password"></b-input>
        </b-field>
        <b-field label="Пароль" v-if="!id">
          <b-input
            type="password"
            icon="key"
            password-reveal
            placeholder="password"
            v-model="model.password"></b-input>
        </b-field>
        <b-field label="Повторите пароль" v-if="!id"
          :type="{'is-danger': errors.has('confirm-password')}"
          :message="[{
            'Пароль обязательное поле для заполнения' : errors.firstByRule('confirm-password', 'required'),
            'Введенные пароль не совпадают' : errors.firstByRule('confirm-password', 'is')
          }]">
          <b-input placeholder="Повторите пароль"
            type="password"
            icon="key"
            name="confirm-password"
            password-reveal
            v-model="confirmPassword"
            v-validate="{ required: true, is: model.password }">
          </b-input>
        </b-field>
        <b-field
          label="Электронной почта"
          :type="{'is-danger': errors.has('email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('email', 'required')
          }]">
            <b-input
              name="email"
              placeholder="Email"
              type="email"
              icon="at"
              :disabled="true"
              v-validate="'required'"
              v-model="model.email">
            </b-input>
        </b-field>
        <b-field
          label="Имя"
          :type="{'is-danger': errors.has('primary_name')}"
          :message="[{
            'Имя обязательное поле для заполнения' : errors.firstByRule('primary_name', 'required')
          }]">
            <b-input
              name="primary_name"
              placeholder="Имя"
              icon="address-card"
              icon-pack="fa"
              v-validate="'required'"
              v-model="model.primary_name">
            </b-input>
        </b-field>
        <b-field
          label="Фамилия"
          :type="{'is-danger': errors.has('secondary_name')}"
          :message="[{
            'Фамилия обязательное поле для заполнения' : errors.firstByRule('secondary_name', 'required')
          }]">
            <b-input
              name="secondary_name"
              placeholder="Фамилия"
              icon="address-card"
              icon-pack="fa"
              v-validate="'required'"
              v-model="model.secondary_name">
            </b-input>
        </b-field>
        <b-field
          label="Телефон"
          :type="{'is-danger': errors.has('phone')}"
          :message="[{
            'Телефон обязательное поле для заполнения' : errors.firstByRule('phone', 'required')
          }]">
            <b-input
              name="phone"
              placeholder="Телефон"
              icon="phone"
              icon-pack="fa"
              v-validate="'required'"
              v-model="model.phone">
            </b-input>
        </b-field>
        <b-field label="Компания" v-if="company_finded">
          <b-field>
            <b-select placeholder="Выбирете компанию" expanded v-model="model.company_id">
              <option
                v-for="option in companies"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearCompany()">X</button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Компания" v-if="!company_finded">
          <b-field>
            <b-autocomplete expanded
              :data="async_data"
              :placeholder="search_placeholder"
              field="search"
              :loading="isFetching"
              @typing="getAsyncDataCompany"
              @select="option => autocompleateСompany(option)">
              
              <template slot="empty">Ничего не найдено</template>
              
              <template slot-scope="props">
                <div class="media">
                  <div class="media-content">
                    {{ props.option.name }}
                  </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </b-field>
        <b-field label="Категория">
          <b-select placeholder="Выбирете категорию" expanded v-model="model.category_id">
            <option
              v-for="option in categories"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-select placeholder="Состояние клиента" expanded v-model="model.is_active">
            <option
              v-for="option in states"
              :value="option.id"
              :key="option.id">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'
import { companySearch } from '@/api'
import debounce from 'lodash/debounce'
export default {
  name: 'ClientForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    const categories = []
    const companies = []
    const states = [
      {
        id: true,
        name: "Активный"
      },
      {
        id: false,
        name: "Не активный"
      }
    ]
    const async_data = []
    return {
      categories: categories,
      companies: companies,
      states: states,
      confirmPassword: '',
      model: {
        id: undefined,
        email: '',
        password: '',
        category_id: null
      },
      company_finded: false,
      isFetching: false,
      search_placeholder: '',
      async_data: async_data
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    this.$store.dispatch('getCategories')
      .then(response => {
        let data = response.data.data;
        data.forEach((item) => {
          this.categories.push(item)
        })
      })
      .catch(error => {
        this.categories = []
      })

    if ($this.id){
      this.$store.dispatch('getClient', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
          if(data.company_id){
            $this.company_finded = true
            $this.companies = []
            $this.companies.push(data.company)
          }
        })
        .catch(error => {
          this.model = {}
        })
    }
  },
  methods: {
    autocompleateСompany(option){
      this.model.company_id = option.id
      this.companies = []
      this.companies.push(option)
      this.company_finded = true
    },
    clearCompany(){
      this.company_finded = false
      this.companies = []
      this.model.company_id = null
    },
    getAsyncDataCompany: debounce(function (search) {
      let $this = this
      if (!search.length) {
        this.async_data = []
        return
      }
      this.isFetching = true
      companySearch(search, $this.$store.state.jwt_admin.token)
      .then(response => {
        let data = response.data.data;
        if (data.length){
          $this.async_data = []
          data.forEach((item) => $this.async_data.push(item))
        }
        else{
          $this.async_data = []
        }
      })
      .catch(error => {
        $this.async_data = []
      })
      .finally($this.isFetching = false)

    }, 500),
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateClient', $this.model)
      }
      else{
        $this.$store.dispatch('createClient', $this.model)
      }
    },
    clearSystem(){
      this.company_finded = false
      this.companies = []
    },
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>